import type { QuoteDocument } from 'paintscout'
import type { UpdateableAreaSubstrate } from '../../area-substrates'

// get area that areaSubstrate belongs to, return the key
export function getQuoteAreaKey(quote: QuoteDocument, areaSubstrate: UpdateableAreaSubstrate): string {
  let r = ''
  Object.keys(quote.areas).forEach((key) => {
    Object.values(quote.areas[key].substrates).forEach((substrate) => {
      substrate.forEach((subSubstrate, i) => {
        if (substrate[i]?.key === areaSubstrate.key) {
          r = key
        }
      })
    })
  })
  return r
}
